import { useCallback, useEffect, useState } from "react";
import { CONTROL_VISIBILITY_CHANGED_EVENT } from "../events/visibilityChanged.js";
import { getSidebarCustomize } from "../sidebar/getSidebarCustomize.js";
function useCustomizeValues(settings) {
    const customize = getSidebarCustomize();
    const getValue = useCallback((setting)=>{
        const s = customize(setting);
        return {
            value: s.get(),
            visible: s.findControls()[0].active()
        };
    }, [
        customize
    ]);
    const [values, setValues] = useState(()=>settings.reduce((p, c)=>{
            p[c] = getValue(c);
            return p;
        }, {}));
    // Listen to changes
    useEffect(()=>{
        for (const setting of settings){
            customize(setting, (value)=>value.bind("change", ()=>{
                    setValues((state)=>({
                            ...state,
                            [setting]: getValue(setting)
                        }));
                }));
        }
        // Listen to visibility changes
        const listener = async ({ detail: { setting } })=>{
            if (Object.values(settings).indexOf(setting) > -1) {
                setValues((state)=>({
                        ...state,
                        [setting]: getValue(setting)
                    }));
            }
        };
        document.addEventListener(CONTROL_VISIBILITY_CHANGED_EVENT, listener);
        return ()=>{
            document.removeEventListener(CONTROL_VISIBILITY_CHANGED_EVENT, listener);
        };
    }, []);
    return values;
}
export { useCustomizeValues };
